import type { IconNode } from '../types';

/**
 * @name owl
 * @description Lucide Lab SVG icon node.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogIHdpZHRoPSIyNCIKICBoZWlnaHQ9IjI0IgogIHZpZXdCb3g9IjAgMCAyNCAyNCIKICBmaWxsPSJub25lIgogIHN0cm9rZT0iIzAwMCIgc3R5bGU9ImJhY2tncm91bmQtY29sb3I6ICNmZmY7IGJvcmRlci1yYWRpdXM6IDJweCIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCj4KICA8ZWxsaXBzZSBjeD0iMTIiIGN5PSI5IiByeD0iOCIgcnk9IjciIC8+CiAgPHBhdGggZD0iTTEyIDlhNCA0IDAgMSAxIDggMHYxMmgtNEM5LjQgMjEgNCAxNS42IDQgOWE0IDQgMCAxIDEgOCAwdjEiIC8+CiAgPHBhdGggZD0iTTggOWguMDEiIC8+CiAgPHBhdGggZD0iTTE2IDloLjAxIiAvPgogIDxwYXRoIGQ9Ik0yMCAyMWEzLjkgMy45IDAgMSAxIDAtNy44IiAvPgogIDxwYXRoIGQ9Ik0xMCAxOS40VjIyIiAvPgogIDxwYXRoIGQ9Ik0xNCAyMC44NVYyMiIgLz4KPC9zdmc+Cg==) - https://lucide.dev/icons/owl
 * @see https://lucide.dev/guide/packages/lucide - Documentation
 *
 * @returns {Array}
 *
 */
const owl: IconNode = [
  ['ellipse', { cx: '12', cy: '9', rx: '8', ry: '7', key: 's0jvfe' }],
  ['path', { d: 'M12 9a4 4 0 1 1 8 0v12h-4C9.4 21 4 15.6 4 9a4 4 0 1 1 8 0v1', key: '1bm9uy' }],
  ['path', { d: 'M8 9h.01', key: '1vya7e' }],
  ['path', { d: 'M16 9h.01', key: '1bdo4e' }],
  ['path', { d: 'M20 21a3.9 3.9 0 1 1 0-7.8', key: '9nnz97' }],
  ['path', { d: 'M10 19.4V22', key: '1fq0w5' }],
  ['path', { d: 'M14 20.85V22', key: '8ayi91' }],
];

export default owl;
